import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

const baseUrl = "http://hdeng2024.cafe24.com/api/controller/admin/contents";

export const adminContentsApiSlice = createApi({
  reducerPath: "adminContentsApiSlice",
  baseQuery: fetchBaseQuery({ baseUrl: baseUrl }),
  endpoints: (builder) => ({
    // 홍보센터 리스트 가져오기
    getContentsList : builder.mutation({
      query : (param : {contentsType : any, page : any, size : number, keyword : string, sortColumn : string, sortOrder : String}) => {
        return{
          url : `/getContentList.php?promContentType=${param.contentsType}&page=${param.page}&size=${param.size}&keyword=${param.keyword}&sortColumn=${param.sortColumn}&sortOrder=${param.sortOrder}`
        }
      }
    }),
    // 홍보센터 저장
    setContent : builder.mutation({
      query : (body : any) => {
        return{
          url : '/setContent.php', method : 'post', body
        }
      }
    }),
    // 홍보센터 상세보기
    getContentDetail : builder.mutation({
      query : (param : {idx : any, contentsType : any}) => {
        return{
          url : `/getContentDetail.php?promContentType=${param.contentsType}&prom_idx=${param.idx}`
        }
      }
    }),
    // 홍보센터 수정하기
    updContent : builder.mutation({
      query : (body : any) => {
        return{
          url : '/updContent.php', method : 'post', body
        }
      }
    }),
    // 홍보센터 공개여부 수정
    updContentActiveStatus : builder.mutation({
      query : (param : {idx : any, status : string}) =>{
        return{
          url : `/updContentActiveStatus.php?prom_idx=${param.idx}&promActiveStatus=${param.status}`
        }
      }
    })
  }),
});

export const {
  useGetContentsListMutation, useSetContentMutation, useGetContentDetailMutation, useUpdContentMutation, useUpdContentActiveStatusMutation
} = adminContentsApiSlice;